export const da = {
    "TRIGGER_LISTEN": "Lytter efter triggere",
    "ASSIST_EMPTY_MSG": "Agent AI lytter aktivt til din samtale og er klar til at hjælpe automatisk, når der bliver trigget.",
    "MYBOT_TRIGGET_LISTEN": "Ingen aktive My Bot-opgaver i øjeblikket",
    "MYBOT_EMTPY_MSG": "For at starte en opgave på My Bot, gå til søgefanen og vælg \"Kør med agentindgange\" for den ønskede opgave.",
    "PROACTIVE_MODE": "Proaktiv Tilstand",
    "SETTINGS": "Indstillinger",
    "HELP_AND_SUPPORT": "Hjælp og Support",
    "HELP": "Hjælp",
    "LANGUAGE": "Sprog",
    "PLAYBOOK": "Playbook",
    "THEME": "Tema",
    "AUTOMATIC": "Automatisk",
    "DARK": "Mørk",
    "LIGHT": "Lys",
    "THEME_DESC": "Dette vil bruge din systemstandardtilstand",
    "DOCUMENTATION": "Dokumentation",
    "DOC_DESC": "Se vores dybdegående dokumentationsartikler.",
    "FAQ_U": "Ofte stillede spørgsmål",
    "FAQ_DESC": "Se ofte stillede spørgsmål om Agent AI.",
    "KORE_ACADEMY": "Kore Akademi",
    "KORE_ACA_DESC": "Lær mere om Agent AI ved at gennemgå akademikurserne.",
    "SEARCH": "Søg",
    "TAP_SEARCH":"Tryk for at søge",
    "MY_BOT": "Min Bot",
    "ASSIST": "Assistere",
    "TRANSCRIPT": "Transkript",
    "HISTORY": "Historik",
    "STARTOVER": "Start forfra",
    "RESTART_INPUTS": "Genstart med fangede indgange",
    "ASKCUSTOMER": "Spørg Kunde",
    "TELLCUSTOMER": "Fortæl Kunde",
    "WELCOME_MSG": "Velkomstbesked",
    "SEND": "Send",
    "SENT": "Sendt",
    "AWAITING": "Afventer svar | Skriv for at fortsætte",
    "OVERRIDE": "Skriv for at fortsætte",
    "OVERRIDE_FILE": "Vedhæft fil for at fortsætte",
    "ACCEPT_RESPONSE": "Svar accepteret",
    "AGENT_ENTERED": "Agent indtrådte",
    "EXPECTED_FORMAT": "Forventet format",
    "INPUT_VALUES": "Indtastningsværdier",
    "RESTART": "Genstart",
    "START_OVER": "Start forfra",
    "RESTART_CAPTURE": "Genstart med fangede indgange",
    "CANCEL": "Afbryd",
    "INTERRUPT_DIALOG": "AFBRUDT DIALOGOPGAVE",
    "RUN": "KØR",
    "RUN_AGENT": "Kør med agentens input",
    "STEP": "Trin",
    "DIALOG_TASK": "Dialogopgave",
    "FAQ": "Ofte stillede spørgsmål",
    "SNIPPET": "Svar",
    "ARTICLE": "Websider",
    "FILE": "Filer",
    "SUGGESTED": "Forslået",
    "ALL_DIALOG": "Alle dialogopgaver",
    "DIALOG_TEXT": "Dialog",
    "INTENT_IDENTIFIED": "Kundeudtryk",
    "NOT_WHAT_LOOKING": "Forkert forslag?",
    "BOT": "Bot",
    "CUSTOMER": "Kunde",
    "YOU": "Du",
    "TERMINATE_CONV": "Afslut dialogopgave",
    "TERMINATE_CONV_DESC": "Er du sikker på, at du vil afslutte dialogopgaven? Agent AI vil ikke længere være i stand til at komme med forslag.",
    "YES_TERMINATE": "Ja, afslut",
    "NO_CANCEL": "Nej, annuller",
    "OVERRIDE_CONTINUE": "Fortsæt med overstyrringsmodus",
    "SUMMARY_TEXT": "Sammendrag",
    "SUBMIT": "Indsend",
    "INTERRUPT_OCCURED": "Afbrydelse opstod",
    "IDENTIFIED_INTENT": "Identificeret hensigt",
    "INTERRUPT_DESC": "Kørsel af dette vil afslutte din igangværende dialogopgave.",
    "ACCEPT_RUN": "Accepter og kør",
    "RUN_LATER": "Kør senere",
    "KNOW_MORE": "Viden mere",
    "MORE_TEXT": "Mere",
    "LESS_TEXT": "Mindre",
    "VIEW_MORE": "Se mere",
    "VIEW_LESS": "Se mindre",
    "SHOW_MORE_FAQ": "Vis flere ofte stillede spørgsmål",
    "SHOW_LESS_FAQ": "Vis færre ofte stillede spørgsmål",
    "SHOW_MORE_ARTICLE": "Vis flere websider",
    "SHOW_LESS_ARTICLE": "Vis færre websider",
    "SHOW_MORE_SNIPPET": "Vis flere svar",
    "SHOW_LESS_SNIPPET": "Vis færre svar",
    "SHOW_MORE_FILES": "Vis flere filer",
    "SHOW_LESS_FILES": "Vis færre filer",
    "VIEW_ALL_DIALOG": "Se alle dialoger",
    "VIEW_FEW_DIALOG": "Se få dialoger",
    "HELP_FULL": "Nyttigt?",
    "THANKYOU": "Tak!",
    "EXPAND_MORE": "Udvid / Mere",
    "CLOSE_TEXT": "Luk",
    "STARTED": "Startede",
    "ENDED": "Afsluttet",
    "VIEW_FULL_ARTICLE": "Vis webside",
    "VIEW_FULL_FILE": "Vis fil",
    "COPIED": "Kopieret",
    "SENTI_ANALY": "Følelsesanalyse",
    "WRONG_SUGGESTION": "Forkert forslag",
    "INCORRECT_INTENT": "Forkert hensigt",
    "ACCIDENTAL_CLICK": "Tilsigtet klik",
    "TIME_TAKING": "Tidskrævende",
    "OTHER": "Andet",
    "PLAYBOOK_EMPTY_MSG": "Vælg playbook",
    "PLAYBOOK_EMPTY_DESC": "Agent AI kan ikke indlæse playbook, da alle tilgængelige playbooks er dynamiske. Klik på 'Vælg playbook' for at få adgang til playbooken.",
    "STAGE": "Fase",
    "PROCEED_TO_CLOSE": "Fortsæt til lukning",
    "RECOMENDED_PLAYBOOK": "ANBEFALET PLAYBOOK",
    "PRIMARY_SCRIPTS": "PRIMÆRE MANUSKRIPTER",
    "DYNAMIC_SCRIPTS": "DYNAMISKE MANUSKRIPTER",
    "RESUME": "Genoptag",
    "ENABLE_CLOSE": "Klik på knappen fortsæt for at aktivere lukningsstadiet",
    "LIST_VIEW": "Listevisning",
    "TERMINATE": "Afslut",
    "MINIMIZE": "Minimer",
    "FILE_NAME":"Filnavn",
    "MAXIMIZE": "Maksimer",
    "NO_SEARCH_RESULT": "Ingen søgeresultat fundet",
    "SENTIMENT_AWAITING": "Afventer følelser",
    "POSITIVE": "Positiv",
    "NEGATIVE": "Negativ",
    "AUTO_SCROLL_TOOLTIP":"Styrer automatisk rulning af Assist-fanen, Min bot & Indholdet af Transkript-fanen",
    "ASSOCIATED_WORK_NOTES": "Tidligere løsningsnotater",
    "AGENT_JOINED_CONV": "Agent tiltrådte samtalen",
    "TAB_TEXT":"Ingen faner aktiveret! Aktivér mindst én fane",
    "AUTOSCROLL_ASSIST": "Auto-Scroll Assist Faneblad Indhold",
    "FILE_SIZE_MSG": "Filstørrelsen skal være inden for 25MB. Prøv igen.",
    "OVERRIDE_BTN": "Overstyr",
    "CHOOSE_FILE": "Vælg fil",
    "SUMMARY_ERROR_TEXT": "Vi beklager, men der opstod et problem med at generere resuméet for denne samtale. Opret venligst dit eget resumé.",
    "ASK_A_QUESTION": "Stil et spørgsmål",
    "COPY": "Kopier",
    "TELL_US_MORE": "Fortæl os mere…",
    "THANKS_FEEDBACK": "Tak for din feedback",
    "SOMETHING_WRONG": "Noget gik galt",
    "CLICK_ERROR_DETAILS": "Klik for at se fejldetaljer",
    "NO_ACTIVE_PLAYBOOK": "Ingen aktiv playbook",
    "REPHRASE_QUESTION": "Kan du omformulere dit spørgsmål eller spørge om noget andet?",
    "INTERNAL_INFO": "Intern information",
    "SOURCES": "Kilder",
    "CONVERSATION_SUMMARY": "Sammenfatning af samtalen",
    "WAITING": "Venter",
    "WIDGET_DISABLED": "Widget er deaktiveret",
    "AI_SETTINGS_DISABLED": "AI-indstillingerne er deaktiveret! Kontakt venligst AI-administratoren",
    "SERVER_CONNECTION_ERROR": "Fejl under forbindelse til serveren",
    "VIEW": "Vis",
    "ATTACHMENT_INPUT": "Vedhæftningsinput",
    "TYPE_SUMMARY": "Skriv resumé",
    "VIEW_FULL_ARTICLE_2": "Se hele artiklen",
    "VIEW_FULL_FILE_2": "Se hele filen",
    "BY":"Af",
    GENERATE_SUMMARY: "Generer resumé",
    DIALOG_WORKFLOWS: "Dialog Workflows",
    SHOW_ALL_DIALOG: "Vis alle dialogopgaver",
    SHOW_ALL_DIALOGS: "Vis alle dialoger",
    CUSTOM_TAB: "Brugerdefineret fane",
    AGENT_INPUT: "Agentens input",
    "CUSTOM_EMPTY_MSG" : "Ingen aktiv workflow i øjeblikket",
    "CUSTOM_TAB_DESC" : "For at starte en workflow, kør en fra listen, der er nede på skærmen.",
    "SUBMIT_OVERALL_FEEDBACK" : "Indsend generelt feedback",
    "FEEDBACK_POPUP_SUBTITLE" : "Tilbagemelding om widgeten og dens funktioner",
    "FEEDBACK_SATISFIED" : "Tilfredsstillende",
    "FEEDBACK_UNSATISFIED" : "Ikke tilfredsstillende",
    "FEEDBACK_PROVIDE_REASONS" : "Giv mere information…",
    "FEEDBACK_TITLE" : "Tilbagemelding",
    "AGENTIC_THINKING" : "Tænker",
    "AGENTIC_AGENT_TITLE" : "Agent",
    "AGENTIC_COPILOT_MODE_TITLE" : "Agentic Copilot-tilstand",
    "AGENTIC_SENDING_MESSAGE" : "Sender...",
    "AGENTIC_COPILOT_DESC" : "Agentic Copilot lytter aktivt til din samtale og er klar til at hjælpe automatisk",
    "AGENTIC_SEARCH_RESULTS" : "Agent Resultater"
}
